import axios from 'axios';
import authService from './auth-service';
import { AZURE_MAPS_LOCATION } from '../urls';
import { MqttConnectionData } from '../types';
import userService from './user-service';

export interface RawZone {
  id: string;
  name: string;
  color: string;
  site_id: string;
  geometry: {
    type: "Polygon" | "MultiPolygon";
    coordinates: number[][][];
  };
}

export interface LocationResponse {
  liberkeeLat: number | null;
  liberkeeUpdateTime: string | null;
  liberkiLon: number | null;
  merakiLat: number | null;
  merakiLon: number | null;
  merakiUpdateTime: string | null;
  vehicleId: string;
}

export interface FloorplanResponse {
  overlayBox: {
    lat1: number;
    lat2: number;
    long1: number;
    long2: number;
  };
  overlayFile: string;
}


class AzureLocationService {

    // public async getVehicleCoordinates(vehicleId:string):Promise<LocationResponse>{
    //   const authHeader = await authService.getAuthHeader();
    //   const result =  await axios({
    //     url: `${AZURE_MAPS_LOCATION}/api/location`,
    //     method: 'GET',
    //     params:{
    //       vehicleId
    //     },
    //     headers: {
    //       Authorization: authHeader,
    //     }
    //   });
    //   return result.data;
    // }

    public determineMqttPresence = async(vehicleId:string):Promise<MqttConnectionData> => {
      const authHeader = await authService.getAuthHeader();
      const user = await userService.fetchRoles();
      const response = await axios({
        url: `${AZURE_MAPS_LOCATION}/api/smartmakers/geolocation`,
        method: 'POST',
        data:{
          entityName:'lueg_fahrzeug',
          recordId: vehicleId,
          currentUserId:user.id
        },
        headers: {
            Authorization: authHeader,
        },
      });
      return response.data;
    }

    public async getZones(siteId: string): Promise<RawZone[]> {
      const authHeader = await authService.getAuthHeader();
      const { data } = await axios.get<RawZone[]>(
        `${AZURE_MAPS_LOCATION}/api/smartmakers/getzones`,
        {
          params: { siteId },
          headers: { Authorization: authHeader },
        }
      );
      return data;
    }

    public triggerPosition = async (vehicleId:string) => {
      const authHeader = await authService.getAuthHeader();
      const user = await userService.fetchRoles();
      return axios({
        url: `${AZURE_MAPS_LOCATION}/api/smartmakers/triggerposition`,
        method: 'POST',
        data: {
          entityName: 'lueg_fahrzeug',
          recordId: vehicleId,
          currentUserId: user.id
        },
        headers: {
          Authorization: authHeader,
        },
      });
    }

    public async getFloorplan(siteId: string): Promise<FloorplanResponse> {
      const authHeader = await authService.getAuthHeader();
      const { data } = await axios.get<FloorplanResponse>(
        `${AZURE_MAPS_LOCATION}/api/smartmakers/floorplan`,
        {
          params: { siteId },
          headers: { Authorization: authHeader },
        }
      );
      return data;
    }

}

const azureLocationService = new AzureLocationService();
export default azureLocationService;